// utils/crypto.js

function bufToBase64 (buf) {
  return btoa(String.fromCharCode(...new Uint8Array(buf)))
}

function base64ToBuf (b64) {
  return Uint8Array.from(atob(b64), c => c.charCodeAt(0))
}

const ITERATIONS = 1
const SALT_LEN = 16
const IV_LEN = 12
const KEY_LEN = 256

async function deriveKey (password, salt) {
  const enc = new TextEncoder()
  const baseKey = await crypto.subtle.importKey(
    'raw',
    enc.encode(password),
    'PBKDF2',
    false,
    ['deriveKey']
  )
  return crypto.subtle.deriveKey(
    {
      name: 'PBKDF2',
      salt,
      iterations: ITERATIONS,
      hash: 'SHA-256',
    },
    baseKey,
    { name: 'AES-GCM', length: KEY_LEN },
    false,
    ['encrypt', 'decrypt']
  )
}

export async function encrypt (password, plainText) {
  const enc = new TextEncoder()
  const salt = crypto.getRandomValues(new Uint8Array(SALT_LEN))
  const iv = crypto.getRandomValues(new Uint8Array(IV_LEN))
  const key = await deriveKey(password, salt)
  const cipherBuf = await crypto.subtle.encrypt(
    { name: 'AES-GCM', iv },
    key,
    enc.encode(plainText)
  )
  const combined = new Uint8Array(salt.length + iv.length + cipherBuf.byteLength)
  combined.set(salt, 0)
  combined.set(iv, salt.length)
  combined.set(new Uint8Array(cipherBuf), salt.length + iv.length)
  return bufToBase64(combined.buffer)
}

export async function decrypt (password, b64token) {
  try {
    const dec = new TextDecoder()
    const data = base64ToBuf(b64token)
    const salt = data.slice(0, SALT_LEN)
    const iv = data.slice(SALT_LEN, SALT_LEN + IV_LEN)
    const ct = data.slice(SALT_LEN + IV_LEN)
    const key = await deriveKey(password, salt)
    const plainBuf = await crypto.subtle.decrypt(
      { name: 'AES-GCM', iv },
      key,
      ct
    )
    return dec.decode(plainBuf)
  } catch (error) {
    console.error('Decryption failed:', error)
    return '[Помилка дешифрування]'
  }
}

export function getPasswordFromToken () {
  try {
    const token = localStorage.getItem('t') || sessionStorage.getItem('t')

    if (!token) {
      console.warn('No token found')
      return null
    }

    const parts = token.split('.')
    if (parts.length !== 3) {
      console.warn('Invalid token format')
      return null
    }

    const payload = JSON.parse(atob(parts[1]))

    return payload.exp ? payload.exp.toString() : null
  } catch (error) {
    console.error('Error extracting password from token:', error)
    return null
  }
}

export async function decryptCalibration (encryptedCalibration) {
  const password = getPasswordFromToken()

  if (!password) {
    console.warn('No password available for decryption')
    return '[Немає ключа]'
  }

  return decrypt(password, encryptedCalibration)
}
